const Resources = {

    table_headers: [
        {
            text: 'Walking#',
            value: 'walking_number',
            type: 'link',
            sort_type: 'text',
        },
        { 
            text: 'Description',
            value: 'description',
            type: 'link',
            with_icon: true,
            src_icon: '/assets/img/svg/customdescriptionicon.svg',
            sort_type: 'text',
        },
        { 
            text: 'Minutes',
            value: 'daily_tasks_minutes',
            sort_type: 'number',
        },
        { 
            text: 'Sq.Feet',
            value: 'sq_ft',
            sort_type: 'number',
        },
        {   
            text:   'Associated Assignments',
            value:  'associated_assignments'
        },
        {   
            text:   'DailyTask(s)',
            value:  'daily_tasks',
            type: 'tasks'
        },
        {   
            text:   'PolicingTask(s)',
            value:  'policing_tasks',
            type:   'tasks',
            class:  'header-blu',
        },
        {   
            text:   'ProjectTask(s)',
            value:  'project_tasks',
            type:   'tasks',
            class:  'header-orange',
        },
    ],

    table_headers_project_complete: [
        {
            text: 'Date',
            value: 'last_completed',
        },
        // {
        //     text: 'Status',
        //     value: 'completed',
        // },
        {
            text: 'Time to complete',
            value: 'actual_minutes',
        },
        {
            text: 'Associate',
            value: 'associate_name',
        },
        {
            text: 'Comment',
            value: 'comment',
        },
        {
            text: 'Project',
            value: 'project_name',
        },
        {
            text: 'Actions',
            value: 'project_name',
        },
    ],

    table_headers_project_history_complete: [
        {
            text: 'Task',
            value: 'task',
        },
        {
            text: 'Date',
            value: 'last_completed',
        },
        {
            text: 'Status',
            value: 'completed',
        },
        {
            text: 'Time to complete',
            value: 'actual_minutes',
        },
        {
            text: 'Associate',
            value: 'associate_name',
        },
        {
            text: 'Comment',
            value: 'comment',
        },
        {
            text: 'Project',
            value: 'project_name',
        },
    ],

    table_headers_room_inspection_history: [
        {
            text: 'Associate',
            value: 'associate',
        },
        {
            text: 'Date',
            value: 'format_assigned_date',
        },
        {
            text: 'Completed Date',
            value: 'format_date',
        },
        {
            text: 'Score',
            value: 'score',
        },
        {
            text: 'Supervisor',
            value: 'supervisor',
        },
        {
            text: 'Inspection',
            value: 'inspection',
        },
    ],

    assignment_table_headers: [
        { 
            name:   'Assignment #',
        },
        {   
            name:   'Description',
        },
        { 
            name:   'Task',
        },
        { 
            name:   'Frequency',
        },
    ],

    task_table_headers: [
        { 
            name:   '#',
        },
        { 
            name:   'Task',
        },
        { 
            name:   'Production standard',
        },
        { 
            name:   'Frequency',
        },
        { 
            name:   '+/- Min',
        },
        {   
            name:   'Min',
        },
        {   
            name:   'Min. Modification',
        },
        {   
            name:   'Default Room Type Task',
            style: 'width: 9%'
        },
        {   
            name:   'S1',
        },
        {   
            name:   'S2',
        },
        {   
            name:   'S3',
        },
        // {   
        //     name:   'Actions',
        // },
    ],

    daily_task_table_headers: [
        { 
            name:   '#',
        },
        { 
            name:   'Default Task for Project Tasks',
            style: 'width: 9%'
        },
        { 
            name:   'Task',
        },
        { 
            name:   'Production standard',
        },
        { 
            name:   'Frequency',
        },
        { 
            name:   '+/- Min',
        },
        {   
            name:   'Min',
        },
        {   
            name:   'Min. Modification',
        },
        {   
            name:   'Default Room Type Task',
            style: 'width: 9%'
        },
        {   
            name:   'S1',
        },
        {   
            name:   'S2',
        },
        {   
            name:   'S3',
        },
        // {   
        //     name:   'Actions',
        // },
    ],

    task_project_table_headers: [
        { 
            name:   '#',
        },
        { 
            name:   'Task',
        },
        { 
            name:   'Production standard',
        },
        { 
            name:   'Frequency',
        },
        { 
            name:   '+/- Min',
        },
        {   
            name:   'Min',
        },
        {   
            name:   'Min. Modification',
        },
        {   
            name:   'Last completed',
        },
        {   
            name:   'Default',
        },
        {   
            name:   'S1',
        },
        {   
            name:   'S2',
        },
        {   
            name:   'S3',
        },
        // {   
        //     name:   'Actions',
        // },
    ],
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Buildings',
            href:   '/buildings',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Rooms',
            href:   '/building-rooms',
            arrow:  " ",
        },
    ],

    frequencies: [
        {       
            id:     1,
            name:   'Never',
        },
        {
            id:     2,
            name:   'Yearly',
        },
        {
            id:     3,
            name:   'Every 6 months',
        },
        {
            id:     4,
            name:   'Every 4 months',
        },
        {
            id:     5,
            name:   'Quarterly',
        },
        {
            id:     6,
            name:   'Every 2 months',
        },
        {
            id:     7,
            name:   'Monthly',
        },
        {
            id:     8,
            name:   'Every other week',
        },
        {
            id:     9,
            name:   'Weekly',
        },
        {
            id:     10,
            name:   'Twice per week',
        },
        {
            id:     11,
            name:   '3 times per week',
        },
        {
            id:     12,
            name:   '4 times per week',
        },
        {
            id:     13,
            name:   '5 times per week',
        },
        {
            id:     14,
            name:   'Daily',
        },
        {
            id:     15,
            name:   'Every 18 months',
        },
        {
            id:     16,
            name:   'Every 24 months',
        },
        {
            id:     17,
            name:   '6 times per week',
        },
    ],

    excel_file_headers: {
        'Building Level Area': 'Building Level Area',
        'Description': 'Description',
        'Description 2': 'Description 2',
        'Door number': 'Door number',
        'Walking Number': 'Walking Number',
        'Parent Room Door Number': 'Parent Room Door Number',
        'Room Type': 'Room Type',
        'Floor Type': 'Floor Type',
        'Sq Feet': 'Sq Feet',
        'Cost Center': 'Cost Center',
        'Closed': 'Closed',
        'Essential Cleaning': 'Essential Cleaning',
        'Work group 2': 'Work group 2',
        'Exclude dailys': 'Exclude dailys',
        'Exclude projects': 'Exclude projects',
        'Fixtures # of units': 'Fixtures # of units',
        'Notes': 'Notes'
    },

    excel_fields_required: {
        area_id: true,
        description: false,
        door_number: false,
        walking_number: false,
        room_id: false,
        room_type_id: true,
        floor_id: false,
        sq_ft: true,
        cost_center_id: false,
        closed: false,
        essential_cleaning: false,
        work_group: false,
        exclude_daily: false,
        exclude_project: false,
        fixtures: true,
        notes: false,
    },

    empty_format_data: [
        {
            'Building Level Area':            '',
            walking_number:     '',
            room_id:            '',
            door_number:        '',
            description:        '',
            room_type_id:       '',
            floor_id:           '',
            sq_ft:              '',
            cost_center_id:     '',
            'Closed':             false,
            'Essential Cleaning': false,
            'Work group 2':         false,
            'Exclude dailys':      false,
            'Exclude projects':    false,
            'Fixtures # of units':  1,
            notes:              '',
        },
    ],

    excel_file_headers_tasks:  {
        'Building Level Area': 'Building Level Area',
        'Door #': 'Door #',
        'Task': 'Task',
        'Frecuency': 'Frecuency',
        '+/- Min': '+/- Min',
        'S1': 'S1',
        'S2': 'S2',
        'S3': 'S3',
    },

    empty_format_data_tasks: [
        {
            'Building Level Area': '',
            'Door #': '',
            'Task': '',
            'Frecuency':   7,
            '+/- Min':  '',
            'S1': false,
            'S2': false,
            'S3': false,
        }
    ],

    excel_fields_required_tasks: {
        room_id:            true,
        task_id:            true,
        frequency_manual:   true,
        minutes_discount:   false,
        shift1:             false,
        shift2:             false,
        shift3:             false,
    },
    helps: [
        {
            label: '¿How to add a Room?', 
            instruction: `https://scribehow.com/embed/Add_a_Room__wyzqLxXHQRWLUj7kxdwlkg?as=scrollable`
        },
        {
            label: '¿How to delete Rooms?', 
            instruction: `https://scribehow.com/embed/How_To_Delete_Rooms__WDE9nqcFSJK51LvvJHT-pA?as=scrollable`
        },
        {
            label: '¿How to search for Rooms?', 
            instruction: `https://scribehow.com/embed/How_to_Search_for_Rooms__To0YkLNISFObI4sVZR8j5Q?as=scrollable`
        },
    ]

}

export default Resources